export async function createSha256(obj) {
    try {
        const jsonString = JSON.stringify(obj, Object.keys(obj).sort((a, b) => a.localeCompare(b)));
        const encoder = new TextEncoder();
        const dataBuffer = encoder.encode(jsonString);
        const hashBuffer = await crypto.subtle.digest('SHA-256', dataBuffer);
        return arrayBufferToHex(hashBuffer);
    }
    catch (error) {
        const errorMessage = 'Failed to create SHA-256 hash from object';
        console.error(`${errorMessage}:`, error);
        throw new Error(errorMessage);
    }
}
function arrayBufferToHex(buffer) {
    const byteArray = new Uint8Array(buffer);
    return Array.from(byteArray)
        .map(byte => byte.toString(16).padStart(2, '0'))
        .join('');
}
